import { VALUE_PICKER_MAP } from './value-pickers'
import type { FilterFieldKey, FilterOperator, FilterValue } from '@/lib/types/filter'
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/popover'

interface FilterValueEditorProps {
  fieldKey: FilterFieldKey
  selectedValues: Array<FilterValue>
  onToggleValue: (value: FilterValue) => void
  onSetValues?: (values: Array<FilterValue>) => void
  operator?: FilterOperator
  allowedProjectIds?: Array<string>
  open: boolean
  onOpenChange: (open: boolean) => void
  children: React.ReactNode
}

export function FilterValueEditor({
  fieldKey,
  selectedValues,
  onToggleValue,
  onSetValues,
  operator,
  allowedProjectIds,
  open,
  onOpenChange,
  children,
}: FilterValueEditorProps) {
  const PickerComponent = VALUE_PICKER_MAP[fieldKey]

  if (!PickerComponent) return <>{children}</>

  return (
    <Popover open={open} onOpenChange={onOpenChange}>
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      <PopoverContent className="w-auto min-w-56 p-0 border-0 text-xs" align="start">
        <PickerComponent
          selectedValues={selectedValues}
          onToggleValue={onToggleValue}
          onSetValues={onSetValues}
          operator={operator}
          allowedProjectIds={allowedProjectIds}
        />
      </PopoverContent>
    </Popover>
  )
}
